import { dcpcApi } from '../dcpcApi';
import { DATASOURCE_PROGRAM_REPORT_COUNT_TAG } from './tags';

const api = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    getDatasourceProgramsReportCount: builder.query({
      query: (params) => ({
        url: '/v2/datasource-programs/report/count',
        params,
        providesTags: [DATASOURCE_PROGRAM_REPORT_COUNT_TAG],
      }),
    }),
  }),
});

export const {
  useLazyGetDatasourceProgramsReportCountQuery,
} = api;
